import {Component, OnInit} from '@angular/core';
import {ROUTES} from '../../app.routes';
import {FaqContent} from './faqContent/go-faq-content';
import {FaqSection} from './faqContent/faq-base';
import {CARD_SIZE} from '../../sdk/component/public-page-template/public-page-template.component';

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.scss'],
    standalone: false
})

export class FaqsComponent extends FaqContent implements OnInit
{
    routes = ROUTES;
    faqs: FaqSection[];
    protected readonly CARDSIZE = CARD_SIZE;

    ngOnInit()
    {
        this.faqs = this.getFaqs();
    }
}